import p from "react";
import { ActionIcon as u } from "@mantine/core";
import d from "./index515.mjs";
var O = Object.defineProperty, o = Object.getOwnPropertySymbols, l = Object.prototype.hasOwnProperty, i = Object.prototype.propertyIsEnumerable, n = (r, t, e) => t in r ? O(r, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : r[t] = e, y = (r, t) => {
  for (var e in t || (t = {}))
    l.call(t, e) && n(r, e, t[e]);
  if (o)
    for (var e of o(t))
      i.call(t, e) && n(r, e, t[e]);
  return r;
}, P = (r, t) => {
  var e = {};
  for (var a in r)
    l.call(r, a) && t.indexOf(a) < 0 && (e[a] = r[a]);
  if (r != null && o)
    for (var a of o(r))
      t.indexOf(a) < 0 && i.call(r, a) && (e[a] = r[a]);
  return e;
};
function b(r) {
  var t = r, {
    className: e,
    children: a,
    controls: f,
    value: c,
    noActive: s
  } = t, m = P(t, [
    "className",
    "children",
    "controls",
    "value",
    "noActive"
  ]);
  const { classes: _, cx: v } = d({ noActive: s }, { name: "RichTextEditor" });
  return /* @__PURE__ */ p.createElement(u, y({
    className: v(_.control, `ql-${f}`, e),
    value: c,
    radius: 0
  }, m), a);
}
b.displayName = "@mantine/rte/ToolbarButton";
export {
  b as ToolbarButton
};
